import OpenAI from 'openai';

// Initialize OpenAI client
const client = new OpenAI({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY_BCH, // Add this to your .env file
    dangerouslyAllowBrowser: true
});

export const messageToAssistant = async (questionQuery, threadId, grade, selectedLanguage) => {
    try {
        // const additionalMessage = `For answers you must follow the reading level of grade ${grade} of a student. Grades are according to the lexile range. Always follow lexile range.
        // -IMPORTANT: You must ALWAYS respond in ${selectedLanguage} language regardless of the input language
        //     - Even if the question is asked in any other language, your response must strictly be in ${selectedLanguage} only
        // `;
        const additionalMessage = `For answers you must follow the reading level of grade ${grade} of a student. Grades are according to the lexile range. Always follow lexile range.
        Give answers in ${selectedLanguage} language.
        `;
        const query = `${additionalMessage} 
        Question: ${questionQuery} 
        Answer: `;

        // Create a message in the thread
        await client.beta.threads.messages.create(threadId, {
            role: "user",
            content: query
        });

        // Poll for assistant's response with a timeout
        const response = await client.beta.threads.runs.createAndPoll(threadId, {
            assistant_id: process.env.REACT_APP_VECTOR_STORE_ID_BCH,
        });

        // Retrieve the latest message
        const messages = await client.beta.threads.messages.list(threadId, { limit: 1 });

        return messages.data[0]?.content[0]?.text?.value || 'No response found.';
    } catch (error) {
        console.error('Error:', error);
        return error.message || 'An error occurred.';
    }
};

